import { makeStyles } from "@fluentui/react-components";
import React, { useRef, useEffect, useState, PropsWithChildren } from "react";

const useStyles = makeStyles({
  base: {
    transition: "opacity 2s ease",
    opacity: 1,
	marginTop: '1rem',
	backgroundColor: '#D5FDD5',
	textAlign: 'center',
	padding: '1rem',
	borderRadius: '0.5rem'
  },
  fadeOut: {
    opacity: 0,
  },
});

export const FadeText: React.FC<PropsWithChildren> = (props) => {
	const elemRef = useRef<HTMLDivElement>(null);
	// const [innerHtml, setInnerHtml] = useState('');
	const [fade, setFade] = useState(false);

	const styles = useStyles();

	useEffect(()=> {
		if (elemRef.current){
			// setInnerHtml(elemRef.current.innerHTML);
			setTimeout(() => {
				setFade(true);
				setTimeout(()=> {
					elemRef.current.remove();
				},2500)
			}, 10000);
		}
	}, []);

	return(
		<div ref={elemRef} className={`${styles.base} ${fade ? styles.fadeOut : ""}`}>
			{props.children}
		</div>
	)
}